import { render } from "./NewsRoomDetails.vue?vue&type=template&id=b1035b6e"
import script from "./NewsRoomDetails.vue?vue&type=script&lang=js"
export * from "./NewsRoomDetails.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__